module.exports = __webpack_public_path__ + "img/icon-advantage-1.baa2b258.png";